import { render, staticRenderFns } from "./AlbumTrackDiscNumber.vue?vue&type=template&id=2adaebbe&scoped=true&"
import script from "./AlbumTrackDiscNumber.vue?vue&type=script&lang=js&"
export * from "./AlbumTrackDiscNumber.vue?vue&type=script&lang=js&"
import style0 from "./AlbumTrackDiscNumber.vue?vue&type=style&index=0&id=2adaebbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adaebbe",
  null
  
)

export default component.exports